// This is a small component that basically loads contentful data
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {Link, BrowserRouter as Router, Route} from "react-router-dom";
import marked from 'marked';
import {Helmet} from 'react-helmet';

//CONNECTING REDUX STORE -> dynamic content reload across site
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

// SINGLEPOST
import SinglePost from './singlepost.jsx'

// FETCH ACTION TYPES
import * as pageActions from '../actions/page-actions.js';

var pages = {};
var blnReFetch = false;

class Single extends Component {

  constructor (props) {
    super(props);

    var pages = JSON.parse(localStorage.getItem("pages"));

    if(pages != null) {

      var activePage = pages.items.findIndex(page => page.fields.slug == this.props.match.params.slug);
      this.state = { pages: pages, activePage: activePage };
    }
    else {
      blnReFetch = true;
    }
  }

  componentWillReceiveProps(newProps, props) {

    // store fetched pages into local storage for use later / refresh
    localStorage.setItem("pages", JSON.stringify(newProps.pages));
  }

  componentWillMount() {

    if(blnReFetch) {
      this.props.actions.fetchPages();
    }
  }

  componentDidMount () {

    window.scrollTo(0, 0)
    var header = document.getElementById("navigation");
    header.classList.remove('active');
    header.style.top = "0";

    window.addEventListener('wheel', function(e) {
      if (document.querySelector('.single-page.article') !== null) {
        var closeArticle = document.getElementById('close-article');

        if(window.pageYOffset > 100) {
          closeArticle.classList.add('active');
        }

        else {
          closeArticle.classList.remove('active');
        }
      }
    });
}

  /* EVENT TO GO BACK SO ARTICLE PAGE */
  goBack(event) {
    history.back();

  }

  getParsedMarkDown(content) {
    return {
      __html: marked(content, {sanitize: true})
    }
  }

  checkForVideos(content, ytSrc) {

    if(ytSrc == "") {
      return content;
    }
    var youtubeEmbedHTML = '<iframe width="560" height="315" src="' + ytSrc + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

    var newContent = content.replace("[ytvideoxxxxxxxxxx]", youtubeEmbedHTML);

    return newContent;
  }

  checkPages() {

    var pages = JSON.parse(localStorage.getItem("pages"));

    if(pages != null) {

      var activePage = pages.items.findIndex(page => page.fields.slug == this.props.match.params.slug);
      this.setState({ pages: pages, activePage: activePage });
    }
  }

  renderPost() {

    if(this.state !== null) {

      const article = this.state.pages.items[this.state.activePage];
      const featImg = this.state.pages.includes.Asset.filter(imageTest => imageTest.sys.id == article.fields.image.sys.id)[0];
      var ytSrc = '';

      if(typeof article.fields.video != 'undefined'){
        ytSrc = article.fields.video;
      }

      var articleImage = {
        backgroundImage: "url(" + featImg.fields.file.url + ")"
      }

      var content = this.checkForVideos(article.fields.content);

      return (
        <div className="article">
          <div className="article-image" style={articleImage}></div>

          <Helmet>
            <title>{article.fields.title}</title>
            <link rel="canonical" href={location.protocol + '//' + location.host} />
            <meta property="og:title" content={article.fields.title} />
            <meta property="og:type" content="article" />
            <meta property="og:url" content={location.href} />
            <meta property="og:image" content={featImg.fields.file.url} />
          </Helmet>
          <div className="article-content-container" dangerouslySetInnerHTML={this.getParsedMarkDown(content)} />
        </div>
      );
    }
    else {
      this.checkPages();
    }
  }

  render() {
    var shareLink = "https://www.facebook.com/sharer/sharer.php?u=" + location.href;

    return (
      <div className="single-page article" id="single-page">
        <div className="single-article-container">
          <div id="close-article" onClick={this.goBack}>Back to articles</div>
          <div className="article-post">
            {this.renderPost()}
            <div className="article-share">
              <h3>Share this</h3>
              <a href="https://twitter.com/share?ref_src=twsrc%5Etfw" className="twitter-share-button" data-show-count="false"><i className="fab fa-twitter"></i></a><script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
              <a href={shareLink} className="share-popup"><i className="fab fa-facebook-f"></i></a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

//CONNECT REDUX FETCH APP STATE
function mapStateToProps(state) {
  return {
  pages: state.pages.contentful};
}

//CONNECT REDUX TRIGGER ACTION TO CHANGE APP STATE
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(pageActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Single);



// WEBPACK FOOTER //
// ./client/components/singlepost.jsx